module.exports = __webpack_public_path__ + "img/v-town-screenshot.f3c4ae54.jpg";